// extracted by mini-css-extract-plugin
export default {"infoTag":"infoTags_infoTag__hT+t5","searchEngine":"infoTags_searchEngine__QMS0s","envButton":"infoTags_envButton__ddcbv","infoWrapper":"infoTags_infoWrapper__QBbpz"};